import React, {useContext, useEffect, useState} from 'react';
import { observer } from "mobx-react-lite";
import {Button, Col, Image, Modal, Spinner} from "react-bootstrap";
import {
    editAssignment,
    fetchAssignmentsCountForUser,
    fetchCurrentUserAssigns, fetchFullInfoAssignmentAndBook, sendEmailToCustomer
} from "../../../http/bookAPI";
import { Context } from "../../../index";
import {
    check,
    fetchReviewerProfilesOverviewApi,
    getCustomerPortalUrl,
    updateUserVirtBalanceTakeAssignmentFromLibraryApi
} from "../../../http/userAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {FaArrowRightFromBracket, FaExplosion} from "react-icons/fa6";
import {
    FaBook, FaBusinessTime,
    FaClock,
    FaCoins, FaMoneyBillWave,
    FaShoePrints,
    FaTypo3
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import {LIBRARY_ROUTE, PAY_ROUTE, USER_DASHBOARD_ROUTE} from "../../../utils/consts";
import Loader from "../../Loader";
import Row from "react-bootstrap/Row";

const normalizeMarketplaceHost = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return null;

    try {
        const url = raw.startsWith('http') ? new URL(raw) : new URL(`https://${raw}`);
        return String(url.hostname || '')
            .toLowerCase()
            .replace(/^www\./, '')
            .replace(/^smile\./, '');
    } catch (_) {
        return raw
            .toLowerCase()
            .replace(/^https?:\/\//, '')
            .replace(/^www\./, '')
            .replace(/^smile\./, '')
            .replace(/\/.*$/, '');
    }
};

const formatMarketplaceDisplay = (value) => {
    const host = normalizeMarketplaceHost(value);
    if (!host) return '-';

    return host
        .split('.')
        .map((part, index) => (
            index === 0
                ? part.charAt(0).toUpperCase() + part.slice(1)
                : part
        ))
        .join('.');
};

const profileCountryMatchesAssignment = (profileCountry, assignmentCountry) => {
    const assignmentHost = normalizeMarketplaceHost(assignmentCountry);
    if (!assignmentHost) return true;

    const profileHost = normalizeMarketplaceHost(profileCountry);
    return Boolean(profileHost && profileHost === assignmentHost);
};

const TakeThisAssignment = observer(({ show, handleClose, assignment, onAssignDataUpdate, totalBonus, returnRoute = LIBRARY_ROUTE }) => {
    const { book } = useContext(Context);
    const { user, poolStore } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const id = user.user.id;

    const navigate = useNavigate();
    const currentTimeInMinutes = Math.floor(Date.now() / 60000);
    const date = new Date((currentTimeInMinutes + assignment?.turnaround_time) * 60 * 1000);
    const isOwnAssignment = Number(user?.user?.id) === Number(assignment?.userId);

// Массив с сокращениями месяцев
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();

    const daysToRead = Math.floor(assignment?.turnaround_time / 60 / 24 );
    const [assLimitReached, setAssLimitReached] = useState(false);
    const [weeklyAssLimitReached, setWeeklyAssLimitReached] = useState(false);
    const [unconfirmedAssLimitReached, setUnconfirmedAssLimitReached] = useState(false);
    const [agreeUncanceled, setAgreeUncanceled] = useState(false);
    const [userCount, setUserCount] = useState([]);
    const [reviewerProfiles, setReviewerProfiles] = useState([]);
    const [selectedReviewerProfileId, setSelectedReviewerProfileId] = useState('');
    const [profilesLoading, setProfilesLoading] = useState(false);

    const isAudibleAssignment = Number(assignment?.assTypeId) === 8;
    const assignmentProfileCountry = isAudibleAssignment
        ? assignment?.audio_promo_code_country
        : assignment?.assignment_prefer_country;
    const availableReviewerProfiles = reviewerProfiles.filter((profile) => {
        if (profile.status !== 'ACTIVE') return false;
        const name = isAudibleAssignment ? profile.audible_name : profile.amazon_name;
        const country = isAudibleAssignment ? profile.audible_country : profile.amazon_country;

        return Boolean(
            name &&
            country &&
            profileCountryMatchesAssignment(country, assignmentProfileCountry)
        );
    });

      const handleSwitchChange = (event) => {
        setAgreeUncanceled(event.target.checked);
    };

    const internalHandleClose = () => {
        handleClose();
        setAgreeUncanceled(false);
        setLoading(false);
        setError('');
    };


    useEffect(() => {
        if (!show || !user?.user?.id) return; // ✅ Проверяем только если модалка открыта и есть ID пользователя
        if (assignment?.assTypeId !== 8) {
            setAgreeUncanceled(true);
        }

        const loadStats = async () => {
            try {
                const data = await fetchAssignmentsCountForUser(user?.user?.id);
                setUserCount(data);
            } catch (error) {
                console.error("Error loading Count", error);
            } finally {
                setLoading(false);
            }
        };

        if (user?.user?.id) {
            loadStats();
        }

        const loadReviewerProfiles = async () => {
            try {
                setProfilesLoading(true);
                const data = await fetchReviewerProfilesOverviewApi();
                const profiles = Array.isArray(data?.profiles) ? data.profiles : [];
                setReviewerProfiles(profiles);

                const matchingProfiles = profiles.filter((profile) => {
                    if (profile.status !== 'ACTIVE') return false;
                    const name = Number(assignment?.assTypeId) === 8 ? profile.audible_name : profile.amazon_name;
                    const country = Number(assignment?.assTypeId) === 8 ? profile.audible_country : profile.amazon_country;
                    const requiredCountry = Number(assignment?.assTypeId) === 8
                        ? assignment?.audio_promo_code_country
                        : assignment?.assignment_prefer_country;

                    return Boolean(
                        name &&
                        country &&
                        profileCountryMatchesAssignment(country, requiredCountry)
                    );
                });
                const defaultProfile = matchingProfiles.find((profile) => profile.is_default);
                setSelectedReviewerProfileId(String((defaultProfile || matchingProfiles[0])?.id || ''));
            } catch (error) {
                const message = error?.response?.data?.message || 'Failed to load reviewer profiles.';
                setError(message);
                toast.error(message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            } finally {
                setProfilesLoading(false);
            }
        };

        loadReviewerProfiles();

        const checkAssignmentsLimit = async () => {
            try {
                const assignments = await fetchCurrentUserAssigns(user.user.id);

                // ✅ 1. Фильтруем задания со статусом "READING"
                const readAssignments = assignments.filter(assignment => (assignment.assignment_status === "READING" ||
                    assignment.assignment_status === "READING_RIDT" ||
                    assignment.assignment_status === "READING_RE" ));
                const assignmentsCount = readAssignments.length;
                setAssLimitReached(user.user.assignment_limit <= assignmentsCount);

                // ✅ 2. Проверяем недельный лимит (10 ассигментов, начатых более 7 дней назад)
                const nowInMinutes = Math.floor(Date.now() / 60000); // Текущее время в минутах
                const oneWeekAgo = nowInMinutes - (7 * 24 * 60); // Время 7 дней назад
                const weeklyAssignments = assignments.filter(assignment =>
                    assignment.start_read_date && assignment.start_read_date >= oneWeekAgo // ✅ Начались в последние 7 дней
                );
                setWeeklyAssLimitReached(weeklyAssignments.length >= 12);


                // ✅ 3. Проверяем лимит 10 неподтвержденных (REPORTED) ассигментов
                const reportedAssignments = assignments.filter(assignment => (assignment.assignment_status === "REPORTED" ||
                    assignment.assignment_status === "REPORTED_RFU" ||
                assignment.assignment_status === "REPORTED_RV"));
                setUnconfirmedAssLimitReached(reportedAssignments.length >= 10);

            } catch (e) {
                const errorMessage = e.response?.data?.message || "An error occurred while calculating user assignments.";
                setError(errorMessage);
                toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            }
        };

        checkAssignmentsLimit();
    }, [show, user?.user?.id, assignment?.id, assignment?.assTypeId, assignment?.assignment_prefer_country, assignment?.audio_promo_code_country]); // ✅ Запускаем проверку при изменении `show` или `user.id`

    const buttonOnClick = () => {
        if (loading) return;
        if (isOwnAssignment) {
            const message = 'You cannot take your own assignment.';
            setError(message);
            toast.error(message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        setAgreeUncanceled(false);
        modifyAssign()
    };
    const handleGoToCustomerPortal = async () => {
        const url = await getCustomerPortalUrl(user?.user?.stripe_customer_id);
        if (url) {

            window.open(url, "_blank"); // 🔥 Открываем в новой вкладке
        }
    };

    const threeLineToast = (title, message, newBalance) => {
        toast.success(
            <div >
                <div style={{ fontSize: '14px', fontWeight: 'bold', lineHeight: '1.4' }}>{title}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{message}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{newBalance}</div>
            </div>,
            { position: "top-center", autoClose: 8000 }
        );
    };




    const modifyAssign = async () => {
        const isAudibleAssignment = Number(assignment?.assTypeId) === 8;
        const selectedReviewerProfile = availableReviewerProfiles.find((profile) => (
            Number(profile.id) === Number(selectedReviewerProfileId)
        ));

        if (!selectedReviewerProfile) {
            setError('Please select an available reviewer profile set.');
            toast.error('Please select an available reviewer profile set.', { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        if (isAudibleAssignment) {
            if (!selectedReviewerProfile.audible_name) {
                setError('Please fill "Audible Reviewer Name" in your Profile.');
                toast.error(`Please fill Audible Reviewer Name in your Profile.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }

            if (!selectedReviewerProfile.audible_country) {
                setError('Please fill "Audible Reviewer Country Site" in your Profile.');
                toast.error(`Please fill "Audible Reviewer Country Site" in your Profile.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
        } else {
            if (!selectedReviewerProfile.amazon_name) {
                setError('Please fill "Amazon Reviewer Name" in your Profile.');
                toast.error(`Please fill Amazon Reviewer Name in your Profile.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }

            if (!selectedReviewerProfile.amazon_country) {
                setError('Please fill "Amazon Reviewer Country Site" in your Profile.');
                toast.error(`Please fill "Amazon Reviewer Country Site" in your Profile.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
        }


        if (!assignment.id) {
            setError('Please select an assignment to modify.');
            return;
        }

        if (isOwnAssignment) {
            setError('You cannot take your own assignment.');
            return;
        }



        setLoading(true);


        try {
            // Обновляем данные пользователя
            const userId = user?.user?.id;
            const assignmentId = assignment?.id;

            const updateUserData = await updateUserVirtBalanceTakeAssignmentFromLibraryApi(
                userId,
                assignmentId,
                totalBonus,
                selectedReviewerProfile.id
            );

           threeLineToast(updateUserData.title, updateUserData.message, updateUserData.newBalance);



            // 📌 Обновляем баланс в MobX store
            const data = await check();
            user.setUser(data);

            if (onAssignDataUpdate) {
                onAssignDataUpdate(assignment);
            }

            book.setPage('');
            book.setSelectedGenre('');
            book.setSelectedPrice('');
            book.setSelectedLanguage('');
            book.setSelectedAssType('');
            book.setSelectedCurrentUserBook('');
            poolStore.setSelectedPool('');
            poolStore.setSelectedPoolItem('');

            await fetchFullInfoAssignmentAndBook (assignment.id).then(data => book.setSelectedCurrentUserAssign(data));

            setAgreeUncanceled(false);
            user.setActiveComponent("AssignFull")
            navigate(USER_DASHBOARD_ROUTE); // ✅ Перенаправляем в дашборд
            handleClose();


        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while modifying the Assignment.';
            setError(errorMessage);
            toast.error(`${errorMessage}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setLoading(false);
        } finally {
            await new Promise(resolve => setTimeout(resolve, 300));
            setLoading(false);
        }
    };

    return (

        <>

            <Modal show={show}  onHide={() => { setError(''); internalHandleClose();}} top backdrop="static" keyboard={false}>
                <div className="modal-content">
                    <div className="modal-header small" style={{ height: 40 }}>
                        <h5 className="modal-title fs-5">Take Assignment</h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => {
                                setError('');
                                internalHandleClose();
                            }}
                        ></button>
                    </div>
                    {loading ? (<Loader />) :(
                     <>
                         <div className="modal-body small">
                                             <>
                                             <Row className="w-100">
                                                 {totalBonus > 0 && (
                                                     <h5 className=" text-success">Earn an Extra Bonus of {totalBonus} Virt</h5>
                                                 )}
                                                 <p
                                                     className="fw-bold fst-italic mb-0 text-muted"
                                                     style={{
                                                         display: '-webkit-box',
                                                         WebkitBoxOrient: 'vertical',
                                                         overflow: 'hidden',
                                                         WebkitLineClamp: 2, // Ограничение до 2 строк
                                                     }}
                                                 >
                                                     Title: {assignment?.book.title || 'N/A'}
                                                 </p>
                                                 <p
                                                     className="fst-italic mb-3 text-muted "
                                                     style={{
                                                         display: '-webkit-box',
                                                         WebkitBoxOrient: 'vertical',
                                                         overflow: 'hidden',
                                                         WebkitLineClamp: 3, // Ограничение до 2 строк
                                                     }}
                                                 >
                                                     Subtitle: {assignment?.book.subtitle || 'N/A'}
                                                 </p>
                                                 {/* Обложка */}
                                                 {/* Картинка */}
                                                 <Col
                                                     xs={12}
                                                     md={4}
                                                     className="d-flex justify-content-center order-1 order-md-1"
                                                 >
                                                     <Image
                                                         src={
                                                             assignment?.book?.cover_file
                                                                 ? `${process.env.REACT_APP_API_URL}covers/${assignment?.book?.cover_file}`
                                                                 : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`
                                                         }
                                                         style={{
                                                             maxWidth: "120px",
                                                             maxHeight: "150px",
                                                             objectFit: "contain",
                                                             borderRadius: "4px",
                                                             backgroundColor: "white",
                                                             marginLeft: "8px",
                                                         }}
                                                     />
                                                 </Col>

                                                 {/* Текстовая часть */}
                                                 <Col
                                                     xs={12}
                                                     md={8}
                                                     className="order-2 mt-2 order-md-2"
                                                     style={{ fontSize: "0.92em" }}
                                                 >
                                                     <p className="mb-0 mt-0 text-muted">
                                                         <FaBook className="me-2 mb-0 mt-0 text-muted" />
                                                         <strong className="text-success m-1">
                                                             {(() => {
                                                                 switch (assignment?.booksTypeId) {
                                                                     case 1:
                                                                         return "Book in Kindle Edition;";
                                                                     case 2:
                                                                         return "Book in Paperback Edition;";
                                                                     case 3:
                                                                         return "Book in Hardcover Edition;";
                                                                     case 4:
                                                                         return "Audiobook;";
                                                                     case 5:
                                                                         return "Boost Existing Review;";
                                                                     case 6:
                                                                         return "Report to Existing Review;";
                                                                     case 7:
                                                                         return "Physical Product;";
                                                                     case 8:
                                                                         return "Physical Product;";
                                                                     case 9:
                                                                         return "Physical Product;";
                                                                     case 10:
                                                                         return "Physical Product;";
                                                                     default:
                                                                         return "N/A";
                                                                 }
                                                             })()}
                                                         </strong>
                                                     </p>

                                                     <p className="mb-0 mt-0 text-muted">
                                                         <FaTypo3 className="me-2 mb-0 mt-0 text-muted" />
                                                         <strong className="text-success m-1">
                                                             {(() => {
                                                                 switch (assignment?.assTypeId) {
                                                                     case 1:
                                                                         return "Universal Assignment;";
                                                                     case 2:
                                                                         return "Kindle Unlimited;";
                                                                     case 3:
                                                                         return "Verified Purchase;";
                                                                     case 4:
                                                                         return "Verified Purchase + Img;";
                                                                     case 5:
                                                                         return "Verified + Search&Buy;";
                                                                     case 6:
                                                                         return "Verified + Search&Buy + Img;";
                                                                     case 7:
                                                                         return "Universal for Audio";
                                                                     case 8:
                                                                         return "Audible Promo Code";
                                                                     case 9:
                                                                         return "Verified Kindle Unlimited";
                                                                     case 10:
                                                                         return "Sponsored Paperback Buyout";
                                                                     case 11:
                                                                         return "Paperback Search&BuyOut";
                                                                     case 12:
                                                                         return "Paperback Verified Purchase + Image";
                                                                     case 13:
                                                                         return "Paperback Verified Purchase + Video";
                                                                     case 14:
                                                                         return "Hardcover Buyout";
                                                                     case 15:
                                                                         return "Hardcover Search&BuyOut";
                                                                     case 16:
                                                                         return "Hardcover Verified Purchase + Image";
                                                                     case 17:
                                                                         return "Hardcover Verified Purchase + Video";
                                                                     case 18:
                                                                         return "Paperback Verified Purchase";
                                                                     case 19:
                                                                         return "Paperback Verified Search&Buy";
                                                                     case 20:
                                                                         return "Hardcover Verified Purchase";
                                                                     case 21:
                                                                         return "Hardcover Verified Search&Buy";
                                                                     case 22:
                                                                         return "Product Buyout;";
                                                                     case 23:
                                                                         return "Product Search&BuyOut;";
                                                                     case 24:
                                                                         return "Product Verified Purchase;";
                                                                     case 25:
                                                                         return "Product Verified Purchase + Image;";
                                                                     case 26:
                                                                         return "Product Verified Purchase + Video;";
                                                                     case 27:
                                                                         return "Product Verified Search&Buy;";
                                                                     case 28:
                                                                         return "Make Helpful Virtalibry Review";
                                                                     case 29:
                                                                         return "Write Report Virtalibry Review";
                                                                     case 30:
                                                                         return "Make Helpful External Review";
                                                                     case 31:
                                                                         return "Write Report External Review";
                                                                     case 32:
                                                                         return "Set Stars Rating";
                                                                     default:
                                                                         return "N/A";
                                                                 }
                                                             })()}
                                                         </strong>
                                                     </p>

                                                     <p className="me-2 mb-0 mt-0 text-muted">
                                                         <FaClock className="me-2" />
                                                         Up to: <strong>{`${month}-${day}`};</strong>
                                                     </p>

                                                     <p className="mb-0 mt-0 text-muted">
                                                         <FaCoins className="me-2 mb-0 mt-0 me-2 text-muted" />
                                                         Expenses:
                                                         <strong className="text-danger m-1">
                                                             { [10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assignment?.assTypeId)
                                                                 ? (assignment?.book_cost_compensation ? `$${assignment.book_cost_compensation}` : "N/A")
                                                                 : [28,29,30,31].includes(assignment?.assTypeId)
                                                                     ? "Tap For Free"
                                                                     : (assignment?.assignment_price_amz || "N/A")
                                                             }
                                                         </strong>
                                                     </p>

                                                     <p className="me-2 mb-0 mt-0 text-muted">
                                                         <FaBusinessTime className="me-2" />
                                                         Time To Post:
                                                         <strong>
                                                             {" "}
                                                             {daysToRead} {daysToRead === 1 ? "Day;" : "Days;"}{" "}
                                                         </strong>
                                                     </p>

                                                     <p className="mb-0 mt-0 text-muted">
                                                         <FaArrowRightFromBracket className="me-2 mb-0 mt-0 text-muted" />
                                                         Earnings: <strong className="">
                                                             {assignment?.assignment_price_reader || "N/A"} Virt
                                                         </strong>
                                                         {totalBonus > 0 && (
                                                             <strong>
                                                                 {" "}
                                                                 <span className="text-success fst-italic">
                                               + {totalBonus} Bonus Virt.
                                                      </span>
                                                             </strong>
                                                         )}
                                                     </p>



                                                     <p className="mb-1 mt-0 text-muted">
                                                         <FaExplosion className="me-2 mb-0 mt-0 text-muted" />
                                                         <strong className="text-success">
                                                             Total Earnings: {assignment?.assignment_price_reader + totalBonus} Virt
                                                         </strong>
                                                     </p>

                                                     {/* Rebate block for 10–17 */}
                                                     {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assignment?.assTypeId) && (
                                                         <p className="mb-0 mt-0 text-muted">
                                                             <FaMoneyBillWave className="me-2 mb-0 mt-0 text-success" />

                                                             <strong className="text-success m-0">
                                                                 Rebate: {assignment?.book_cost_compensation ? `+$${assignment.book_cost_compensation}` : "N/A"}
                                                             </strong><span className="text-muted"> (after approval)</span>
                                                         </p>
                                                     )}





                                                 </Col>

                                             </Row>
                                                 <Row>
                                                     <p className="mb-0 mt-2 text-muted">
                                                         <FaShoePrints className="me-2 mb-0 mt-0 text-muted" />
                                                         <strong className="text-success m-0">What To Do: </strong>
                                                         <span className="mb-0 mt-0 fst-italic">
                                                  {(() => {
                                                 switch (assignment?.assTypeId) {
                                                                                case 1:
                                                        return (
                                                            <>
                                                                <div className="mt-1"><span className="fw-semibold">Step 1:</span> Download the book for free.</div>
                                                                <div className="mt-1"><span className="fw-semibold">Step 2:</span> Read the entire book carefully.</div>
                                                                <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post an honest Amazon review.</div>
                                                                <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> No Verified Purchase Stamp, just Review.</strong></div>
                                                            </>
                                                        );

            case 2:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Use a paid or trial Kindle Unlimited subscription.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Read fully until Kindle shows “Read”.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post your honest Amazon review.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> No Verified Purchase Stamp, just Review.</strong></div>
                    </>
                );

            case 3:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Buy the Kindle book on Amazon.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Read fully until Kindle Device shows “Read”.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post an Amazon review honestly.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 4:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Buy the Kindle book on Amazon.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Read fully until Kindle Device shows “Read”.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post review with one photo attached to this Assignment.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 5:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Search book on Amazon with Search Query.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Buy it and read fully until Kindle Device shows “Read”.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post your Amazon review honestly.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 6:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Search book on Amazon with Search Query.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Buy it and read fully until Kindle Device shows “Read”.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post review with one photo attached to this Assignment.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 7:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Receive audiobook files for listening.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Listen carefully to the audiobook fully.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post your review on Amazon page.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> No Verified Purchase Stamp, just Review.</strong></div>
                    </>
                );

            case 8:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Receive an Audible promo code.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Download audiobook using given code.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Listen and post Audible honest review.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> No Verified Purchase Stamp, just Review.</strong></div>
                    </>
                );

            case 9:
                return (
                    <>
                        <div className="mt-1"><span className="fw-semibold">Step 1:</span> Use paid Kindle Unlimited subscription.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> Read fully until Kindle Device shows “Read”.</div>
                        <div className="mt-1"><span className="fw-semibold">Step 3:</span> Post your honest Amazon review.</div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 10:
                return (
                    <>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 1:</span> Buy the physical Paperback book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                        </div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> No public review is required, just BuyOut.</div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 3:</span> Upload proof of purchase as a screenshot or photo of Order.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 5:</span> After our staff verifies the proof, you will receive your Virt and full reimbursement of the purchase price.
                        </div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> No Review Required, Proof of Purchase Mandatory.</strong> </div>
                    </>
                );

                                                     case 11:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Search for the physical <b>Paperback</b> book on Amazon manually — do not use direct links.
                                                                     Use the search phrase provided by the author to locate the book, then find it by its title or author name and add it to your cart.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Purchase the book using your own Amazon account.
                                                                     Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> After receiving your order, take clear photos or screenshots confirming your purchase — for example, your Amazon order details and the package or book itself.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload these proof-of-purchase files here and click <b>“Turn In”</b> to submit them for verification.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> Our team will review the uploaded files.
                                                                     Once verified, you will receive your Virt reward and full reimbursement of the purchase price.
                                                                 </div>
                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Note:</span> This type of assignment does not require posting a review.
                                                                     The goal is to confirm a real purchase made directly through Amazon search results.
                                                                 </div>
                                                             </>
                                                         );


                                                     case 12:
                return (
                    <>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 1:</span> Buy the physical Paperback book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 2:</span> Post your review on Amazon and attach <b>at least 3 real photos</b> of the physical book.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 3:</span> Make sure the review shows the <b> Verified Purchase</b> label for credibility.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 4:</span> After our staff verifies the proof, you will receive your Virt and full reimbursement of the purchase price.
                        </div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 13:
                return (
                    <>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 1:</span> Buy the physical Paperback book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 2:</span> Post your review on Amazon and attach a <b>real video of the physical book</b> as proof of purchase, recorded with your own device.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 3:</span> Make sure the review shows the <b> Verified Purchase</b> label for credibility.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 4:</span> After our staff verifies the proof, you will receive your Virt and full reimbursement of the purchase price.
                        </div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 14:
                return (
                    <>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 1:</span> Buy the physical Hardcover book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                        </div>
                        <div className="mt-1"><span className="fw-semibold">Step 2:</span> No public review is required, just BuyOut.</div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 3:</span> Upload proof of purchase as a
                            screenshot or photo of Order.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 5:</span> After our staff verifies the proof,
                            you will receive your Virt and full reimbursement of the purchase price.
                        </div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> No Review Required, Proof of Purchase Mandatory.</strong> </div>
                    </>
                );

                                                     case 15:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Search for the physical <b>Hardcover</b> edition of the book on Amazon manually — do not use direct links.
                                                                     Use the search phrase provided by the author to locate the book, then find it by its title or author name and add it to your cart.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Purchase the Hardcover book using your own Amazon account.
                                                                     Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Once your order arrives, take clear photos or screenshots confirming your purchase — for example, your Amazon order details, the delivery package, and the Hardcover book itself.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload these proof-of-purchase files here and click <b>“Turn In”</b> to submit them for verification.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> Our team will review the uploaded files.
                                                                     Once verified, you will receive your Virt reward and a full reimbursement of the purchase price.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Note:</span> This type of assignment does not require posting a review.
                                                                     The purpose is to confirm a legitimate Hardcover purchase made directly through Amazon search results.
                                                                 </div>
                                                             </>
                                                         );


                                                     case 16:
                return (
                    <>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 1:</span> Buy the physical Hardcover book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 2:</span> Post your review on Amazon and attach <b>at least 3 real photos</b> of the physical book.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 3:</span> Make sure the review shows the <b> Verified Purchase</b> label for credibility.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 4:</span> After our staff verifies the proof, you will receive your Virt and full reimbursement of the purchase price.
                        </div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );

            case 17:
                return (
                    <>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 1:</span> Buy the physical Hardcover book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 2:</span> Post your review on Amazon and attach a <b>real video of the physical book</b> as proof of purchase, recorded with your own device.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 3:</span> Make sure the review shows the <b> Verified Purchase</b> label for credibility.
                        </div>
                        <div className="mt-1">
                            <span className="fw-semibold">Step 4:</span> After our staff verifies the proof, you will receive your Virt and full reimbursement of the purchase price.
                        </div>
                        <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                    </>
                );
                                                     case 18:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Buy the physical Paperback book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Post your honest review on Amazon using the same account you bought the book with.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Make sure the review shows the <b> Verified Purchase</b> label for credibility.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload proof of purchase as a screenshot or photo of Order.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> After our staff verifies the proof, you will receive your Virt and full reimbursement of the purchase price.
                                                                 </div>
                                                                 <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                                                             </>
                                                         );
                                                     case 19:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Search for the physical <b>Paperback</b> book on Amazon manually — do not use direct links.
                                                                     Use the search phrase provided by the author to locate the correct book by its title or author name, then add it to your cart.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Purchase the book using your own Amazon account.
                                                                     You will later receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> After receiving your order and reading the book, post your honest review on Amazon using the same account you made the purchase with.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Make sure your review displays the <b>Verified Purchase</b> label — this confirms your feedback is genuine.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> Upload clear proof of purchase — for example, screenshots of your Amazon order details and photos of the received Paperback book.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 6:</span> Click <b>“Turn In”</b> after uploading your files.
                                                                     Our team will review your proof and confirm your Verified Purchase review.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> A <b>Verified Purchase</b> label is required for this assignment.
                                                                     Please ensure the review is posted from the same account used to buy the book and that your uploaded proofs clearly confirm the purchase.
                                                                 </div>
                                                             </>
                                                         );


                                                     case 20:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Buy the physical Hardcover book on Amazon. Later, you will receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Post your honest review on Amazon using the same account you bought the book with.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Make sure the review shows the <b> Verified Purchase</b> label for credibility.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload proof of purchase as a screenshot or photo of Order.
                                                                 </div>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> After our staff verifies the proof, you will receive your Virt and full reimbursement of the purchase price.
                                                                 </div>
                                                                 <div className="mt-2"><span className="fw-semibold">Expectations:</span><strong> Verified Purchase Stamp Required.</strong> </div>
                                                             </>
                                                         );
                                                     case 21:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Search for the physical <b>Hardcover</b> edition of the book on Amazon manually — do not use direct links.
                                                                     Use the search phrase provided by the author to locate the correct book by its title or author name, then add it to your cart.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Purchase the Hardcover book using your own Amazon account.
                                                                     You will later receive a full reimbursement of the book’s retail price <b>excluding delivery costs</b>.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> After receiving your order and reading the book, post your honest review on Amazon using the same account you used for the purchase.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Ensure your review displays the <b>Verified Purchase</b> label — it confirms your review is authentic and linked to a real purchase.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> Upload clear proof of your purchase — such as screenshots of your Amazon order details and photos of the received Hardcover book or its package.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 6:</span> Click <b>“Turn In”</b> after uploading your files.
                                                                     Our team will carefully review the provided proof and confirm your Verified Purchase review.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> A <b>Verified Purchase</b> label is required for this type of assignment.
                                                                     Please make sure your review is posted from the same Amazon account used for the Hardcover purchase and that all uploaded proofs clearly confirm the order.
                                                                 </div>
                                                             </>
                                                         );
                                                     case 22:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Buy the assigned <b>physical product</b> on Amazon.
                                                                     Later, you will receive a full reimbursement of the product’s retail price <b>excluding delivery costs</b>.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> No public review is required — this is a <b>BuyOut</b> only.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Upload clear proof of purchase — for example, a screenshot of your Amazon order details or a photo of the product/package.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> After our staff verifies your proof, you will receive your Virt reward and full reimbursement.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> <strong>No Review Required — Proof of Purchase Mandatory.</strong>
                                                                 </div>
                                                             </>
                                                         );

                                                     case 23:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Search for the <b>physical product</b> on Amazon manually — do not use direct links.
                                                                     Use the search phrase provided in your assignment to find the correct item by name or brand and add it to your cart.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Purchase the product using your own Amazon account.
                                                                     Later, you will receive a full reimbursement of the retail price <b>excluding delivery costs</b>.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> After receiving your order, take clear photos or screenshots confirming your purchase — such as your Amazon order details and the delivered product or package.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload these proof-of-purchase files and click <b>“Turn In”</b> to submit them for verification.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> Our team will review the uploaded proofs.
                                                                     Once verified, you will receive your Virt reward and full reimbursement.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Note:</span> This type of assignment does not require posting a review.
                                                                     Its purpose is to confirm a <b>real product purchase</b> found through organic Amazon search results.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 24:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Buy the assigned <b>product</b> on Amazon using your own account.
                                                                     Later, you will receive a reimbursement of the product’s price <b>excluding delivery costs</b>.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> After receiving your order and trying the product, post your honest review on Amazon.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Make sure your review displays the <b>Verified Purchase</b> label — it confirms that your review is linked to a real purchase.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload a screenshot of your posted review and your Amazon order details.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 5:</span> Click <b>“Turn In”</b> to submit your proofs for verification.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> The review must appear on the correct Amazon listing and show the <b>Verified Purchase</b> label.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 25:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Purchase the assigned <b>product</b> on Amazon and wait until it is delivered.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Try the product and post your genuine review on Amazon, ensuring it has the <b>Verified Purchase</b> tag.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Include 1–2 photos of the product in your review (for example, how it looks in real life).
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload screenshots of your review and order details, then click <b>“Turn In”</b>.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> Review must show both the <b>Verified Purchase</b> label and your uploaded product images.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 26:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Buy and test the assigned <b>product</b> on Amazon.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Post your honest review including a short <b>video</b> demonstrating the product (its look, function, or unboxing).
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Ensure your review shows the <b>Verified Purchase</b> label.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload a screenshot of the review and your order details, then click <b>“Turn In”</b>.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> Review must include a <b>video</b> and be marked as <b>Verified Purchase</b> for full credit.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 27:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Search for the assigned <b>product</b> on Amazon manually — do not use direct links.
                                                                     Use the search phrase provided in your assignment to find it by name or brand and add it to your cart.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Purchase the product with your Amazon account and wait for delivery.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> After receiving it, post your honest <b>Verified Purchase</b> review on Amazon.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload screenshots of your review and order details as proof, then click <b>“Turn In”</b>.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> The review must show the <b>Verified Purchase</b> tag and match the assigned product found through search.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 28:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Open the review assigned to you on Amazon — it was posted via Virtalibry and belongs to another user.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Scroll down below the review text and tap the <b>“Helpful”</b> button.
                                                                     This helps the system highlight genuine and valuable reviews within Amazon’s algorithm.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Take a clear screenshot showing the review and that the <b>Helpful</b> button was clicked (usually it becomes highlighted or changes color).
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload your screenshot in the system, then click <b>“Turn In”</b>.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> Ensure your screenshot clearly displays the <b>review text</b>, the <b>reviewer name</b>, and the highlighted <b>Helpful</b> indicator.
                                                                     Only reviews marked as “Helpful” will be counted as completed.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 29:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Open the assigned Virtalibry review on Amazon and carefully read it.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Scroll to the bottom of the review and click <b>“Report”</b> (the flag icon).
                                                                     Choose the option that best fits the issue — for example, “Inappropriate content” or “Spam”.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Take a screenshot showing that the report form was opened or submitted for that specific review.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload the screenshot in the system and click <b>“Turn In”</b>.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> Your report must correspond to the review specified in your assignment.
                                                                     Please make sure that the screenshot clearly displays both the <b>review content</b> and the <b>report action</b>.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 30:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Locate the external Amazon review specified in your assignment (it was <b>not</b> created through Virtalibry).
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Scroll below that review and tap the <b>“Helpful”</b> button to support it.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Take a screenshot clearly showing that the <b>Helpful</b> button was pressed — it should appear highlighted or active.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload your screenshot in Virtalibry and click <b>“Turn In”</b>.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> The review must match the one indicated in your assignment.
                                                                     Ensure your screenshot includes both the <b>review text</b> and the <b>Helpful</b> mark.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 31:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Open the external (non-Virtalibry) review linked in your assignment.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Click the <b>“Report”</b> or flag icon under the review to report it to Amazon.
                                                                     Select the most relevant reason from the list.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Take a screenshot showing the opened report form or confirmation screen for that review.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Upload the screenshot to Virtalibry and click <b>“Turn In”</b> to complete the task.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> The report must apply to the correct external review.
                                                                     Screenshots should clearly show the <b>review text</b>, the <b>report button</b>, and preferably the <b>Amazon interface</b>.
                                                                 </div>
                                                             </>
                                                         );

                                                     case 32:
                                                         return (
                                                             <>
                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 1:</span> Get the assigned <b>Kindle edition</b> on Amazon.
                                                                     If this is a free promo assignment, use the promo period shown by Amazon.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 2:</span> Open the book in a <b>Kindle reader or mobile Kindle app</b>.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 3:</span> Set a <b>star rating only</b>. Do not write a text review for this assignment.
                                                                 </div>

                                                                 <div className="mt-1">
                                                                     <span className="fw-semibold">Step 4:</span> Take a clear screenshot from the Kindle reader/app showing the completed rating and your reviewer name/account.
                                                                 </div>

                                                                 <div className="mt-2">
                                                                     <span className="fw-semibold">Expectations:</span> Staff must be able to confirm the correct Kindle book, the rating action, and the reviewer identity from your proof.
                                                                 </div>
                                                             </>
                                                         );




                                                     default:
                return <div>Undefined Assignment Type. Please contact support.</div>;
        }
    })()}
                                                         </span>
                                                     </p>

                                                 </Row>

                                                 {assignment?.assTypeId === 1 && userCount?.takenAssTypeOneLast14Days > 8 && (
                                                     <>
                                                         <div className="alert alert-danger mt-4">
                                                             <h5 style={{ color: 'red', lineHeight: '1.5' }}>
                                                                 <strong>Warning!</strong> <br />
                                                                 The number of <strong>Free Unverified Universal Assignments</strong> is disproportionately high compared to <strong>Kindle Unlimited</strong> and <strong>Verified Purchase</strong> ones.
                                                             </h5>

                                                             <p className="mb-1">Universal Assignments (last 14 days): <strong>{userCount?.takenAssTypeOneLast14Days}</strong></p>
                                                             <p className="mb-3">Kindle Unlimited & Verified Purchase (last 14 days): <strong>{userCount?.takenAssTypeElseLast14Days}</strong></p>

                                                             <p className="mb-2">
                                                                 Please <strong>avoid completing only</strong> Universal Assignments (Free File Downloads), or relying too heavily on them. We <strong>strongly recommend</strong> alternating with <strong>Verified Purchase</strong> or <strong>Kindle Unlimited</strong> assignments whenever possible.
                                                             </p>

                                                             <p className="mb-2">
                                                                 Performing a <strong>high percentage</strong> of Universal Assignments may result in your <strong>Amazon reviewer account being flagged or permanently banned</strong>. If that happens, *all reviews you've submitted may be deleted* — affecting <em>not only you</em>, but also the authors and other reviewers who rely on this platform.
                                                             </p>

                                                             <p className="mb-2">
                                                                 Our system includes a <strong>reviewer rating system</strong>. If your reviews are removed from Amazon and users begin reporting them as low-quality, your <strong>review quality rating will significantly drop</strong>.
                                                             </p>

                                                             <p className="mb-2">
                                                                 For now, this is just a <strong>warning</strong>. However, if these patterns continue, we may need to introduce <strong>stricter policies</strong> in the near future.
                                                             </p>

                                                             <p className="mb-0">
                                                                 <strong>Remember:</strong> *The quality of your reviews and the natural timing of their publication are essential.*<br />
                                                                 <strong>Take your time — rushing is not the way forward.</strong>
                                                             </p>
                                                         </div>


                                                     </>
                                                 )}

                                                 {isOwnAssignment && (
                                                     <div className="alert alert-warning mt-3 mb-2">
                                                         This is your assignment. You can view it here, but you cannot take your own assignment.
                                                     </div>
                                                 )}

                                                 {assignment?.assTypeId === 5 || assignment?.assTypeId === 6 ? (
                                                     <>
                                                         <div
                                                             className="d-inline-flex justify-content-start flex-wrap rounded-2 mt-3 mb-2 shadow-lg p-3 gap-1">
                                                             <strong className="mt-0 text-danger">ATTENTION: </strong>
                                                             <p className="mt-0 mb-0 text-muted">This is a "Search and Buy" assignment.
                                                                 Right now, you will receive 50%, and after confirming the Search & Buy link, you'll get the remaining 50%.
                                                                 <b><p className="mt-2 text-success">First part now:
                                                                     ({assignment?.assignment_price_reader / 2 || 'N/A'} Virt) <br/>
                                                                     Second part after validate link:
                                                                     ({assignment?.assignment_price_reader / 2 || 'N/A'} Virt)<br/>
                                                                     Total: {assignment?.assignment_price_reader || 'N/A'} Virt
                                                                 </p></b>

                                                             </p>

                                                         </div>
                                                     </>
                                                 ) : ('')}


                                             </>

                                        {assignment?.assTypeId === 8 && (
                                            <div className="alert alert-danger shadow-sm rounded mt-3 p-3 mb-3">
                                             <h5 className="text-danger fw-bold">Attention!!!</h5>
                                          <p className="mb-0">
                                          This <strong>Assignment</strong> is for an audiobook on <strong>Audible</strong>.
                                         To complete it, you’ll receive a <strong>promo code</strong> from the book's author, which grants you free access to download and listen to the book.
                                         <strong> Once taken, this assignment cannot be canceled</strong> because it contains sensitive data—the promo code.
                                         If you agree, turn on the switch below, and the "Take this Assignment" button will be unlocked.
                                           </p>


                                         </div>
                             )}
                             {assignment?.assTypeId === 8 && (
                                 <div className="form-check form-switch d-flex align-items-center w-100 mb-2">
                                     <input
                                         className="form-check-input bg-opacity-75 bg-success border-success text-white me-2"
                                         type="checkbox"
                                         id="agreeSwitch"
                                         style={{
                                             transform: "scale(1)",
                                             flexShrink: 0,
                                             marginTop: "0",
                                             verticalAlign: "middle",
                                         }}
                                         onChange={handleSwitchChange}
                                     />
                                     <label
                                         className="form-check-label ms-1 lh-base text-break flex-grow-1"
                                         htmlFor="agreeSwitch"
                                         style={{
                                             display: "flex",
                                             alignItems: "center",
                                         }}
                                     >
      <span className="d-none d-sm-inline">
        I Understand that this Assignment is UnCanceled
      </span>
                                         <span className="d-inline d-sm-none">
      I Understand the Uncanceling Rule
      </span>
                                     </label>
                                 </div>
                             )}









                         </div>
                     </>
                    )}




                    <div className="modal-footer d-flex align-items-center gap-2 flex-nowrap" style={{ minHeight: 60 }}>
                        <div className="flex-grow-1" style={{ minWidth: 0, maxWidth: 360 }}>
                            <select
                                className="form-select form-select-sm border-secondary"
                                value={selectedReviewerProfileId}
                                onChange={(event) => setSelectedReviewerProfileId(event.target.value)}
                                disabled={profilesLoading || availableReviewerProfiles.length <= 1}
                            >
                                {availableReviewerProfiles.length === 0 ? (
                                    <option value="">No compatible reviewer profile</option>
                                ) : availableReviewerProfiles.map((profile) => {
                                    const reviewerName = isAudibleAssignment ? profile.audible_name : profile.amazon_name;
                                    const reviewerCountry = isAudibleAssignment ? profile.audible_country : profile.amazon_country;
                                    const defaultLabel = profile.is_default ? ' (Default)' : '';

                                    return (
                                        <option key={profile.id} value={profile.id}>
                                            {`${reviewerName}${defaultLabel} / ${formatMarketplaceDisplay(reviewerCountry)}`}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                        <div className="d-flex align-items-center gap-2 ms-auto flex-nowrap">
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary text-nowrap"
                                onClick={() => {
                                    setError('');
                                    setAgreeUncanceled(false);
                                    internalHandleClose();
                                }}
                                disabled={loading}
                            >
                                Close
                            </button>
                            <Button
                                type="button"
                                variant="success"
                                className="btn btn-sm btn-success text-nowrap"
                                onClick={buttonOnClick}
                                disabled={loading || profilesLoading || availableReviewerProfiles.length === 0 || weeklyAssLimitReached || unconfirmedAssLimitReached || !agreeUncanceled || isOwnAssignment}
                            >
                                {loading ? (
                                    <Spinner as="span" animation="border" size="sm" />
                                ) : (
                                    isOwnAssignment ? "Your Assignment" : "Take this Assignment"
                                )}
                            </Button>
                        </div>


                    </div>
                </div>
            </Modal>
        </>
    );
});

export default TakeThisAssignment;
